var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.7318 0.289983L5.91256 4.16998L2.09332 0.289983C2.00226 0.197267 1.8941 0.12371 1.77502 0.0735207C1.65594 0.0233317 1.52828 -0.00250244 1.39936 -0.00250244C1.27044 -0.00250244 1.14278 0.0233317 1.0237 0.0735207C0.904624 0.12371 0.796458 0.197267 0.7054 0.289983C0.321507 0.679983 0.321507 1.30998 0.7054 1.69998L5.22352 6.28998C5.60741 6.67998 6.22755 6.67998 6.61144 6.28998L11.1296 1.69998C11.5135 1.30998 11.5135 0.679983 11.1296 0.289983C10.7457 -0.0900172 10.1157 -0.100017 9.7318 0.289983Z",
    fill: "#919EAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.f06a4a21becbae3fb18f1dc9406f2b8f.svg";
export { ForwardRef as ReactComponent };